import { saveVote, removeVote } from "@/redux/features/brainstormers/thunk";
import {
  resetVotingStatus,
  updateIdeas,
  updateIdea
} from "@/redux/features/brainstormers/slice";
import { getVotingStatus } from "@/helpers/ideas";

const handleError = (translate, toast, errorCodes = [], votingLimit = null) => {
  if (!toast.isActive("idea-toast")) {
    toast({
      id: "idea-toast",
      title: errorCodes.includes("voting_limit_exceeded")
        ? translate("errors.voteLimitReached", { count: votingLimit })
        : translate("errors.sorrySomethingWentWrong"),
      status: "error"
    });
  }
};

export const handleVote = async (
  id,
  filteredArray,
  dispatch,
  projectId,
  brainstormerId,
  translate,
  toast,
  votingLimit
) => {
  try {
    const res: any = await dispatch(
      saveVote({ projectId, brainstormerId, ideaId: id })
    );

    const errorCodes =
      res.payload.data?.errors.map((error) => error.code) ?? [];

    if (errorCodes.length) {
      handleError(translate, toast, errorCodes, votingLimit);
      return;
    }
    const updatedIdea = {
      ...filteredArray,
      currentUserVoted: true,
      votesCount: filteredArray.votesCount + 1
    };

    await Promise.all([
      dispatch(resetVotingStatus()),
      dispatch(updateIdeas({ id, idea: updatedIdea })),
      dispatch(updateIdea(updatedIdea))
    ]);
    if (!toast.isActive("vote-toast")) {
      toast({
        title: translate("brainstormers.addVotesDesc"),
        id: "vote-toast",
        status: "success"
      });
    }
    // eslint-disable-next-line no-unused-vars
  } catch (error) {
    handleError(translate, toast);
  }
};

export const handleUnVote = async (
  id,
  filteredArray,
  dispatch,
  projectId,
  brainstormerId,
  translate,
  toast
) => {
  try {
    const res: any = await dispatch(
      removeVote({ projectId, brainstormerId, ideaId: id })
    );
    const responseStatus = res.payload.status;
    if (responseStatus) {
      handleError(translate, toast);
      return;
    }
    const updatedIdea = {
      ...filteredArray,
      currentUserVoted: false,
      votesCount: filteredArray.votesCount - 1
    };

    await Promise.all([
      dispatch(updateIdeas({ id, idea: updatedIdea })),
      dispatch(updateIdea(updatedIdea))
    ]);
    if (!toast.isActive("unvote-toast")) {
      toast({
        title: translate("brainstormers.removeVoteDesc"),
        id: "unvote-toast",
        status: "warning"
      });
    }
    // eslint-disable-next-line no-unused-vars
  } catch (error) {
    handleError(translate, toast);
  }
};

export const getVotingStatusWrapper = (votingStartAt, votingEndAt) => {
  return getVotingStatus(votingStartAt, votingEndAt);
};
